import { logEvent, logException } from '#/features/logging/logging';

/**
 * This function should be called as an escape hatch to avoid keeping the user stuck in a bad state.
 *  One example of such an issue is when the user can no longer sign in due to a full localStorage.
 * As the system evolves, this function should include cleanup logic for other Web APIs used (e.g. `IndexedDB`, `Cache Storage API`, etc…)
 */
export function resetSystemState(): void {
  try {
    logEvent('Attempting to reset system state…');
    window.localStorage.clear();
    logEvent('System state reset successful.');
  } catch (err) {
    const message = 'Failed to reset system state.';
    logException(new Error(message, { cause: err }));
  }
}
/**
 * Checks whether the current window is embedded in an iframe.
 */
export function isEmbedded(): boolean {
  return window.self !== window.top;
}
